<template lang="pug">
  app-modal(
    :titulo="titulo",
    v-if="showModal"
    :width="1200"
    :height="700"
    @closeModal="closeModal"
  )
    template(slot="body")
      validation-observer(ref='validation' tag='div')
        el-collapse(v-for='(laudo, index) in laudos' :key='index')
          el-collapse-item(:name="laudo.id").content
            template(slot='title')
              el-tooltip(:content="getLabel(laudo)" placement="top")
                i(v-if="!laudo.aptoParaGerar" class="header-icon el-icon-warning warning-icon")
              el-tooltip(content="Apto para gerar" placement="top")
                i(v-if="laudo.aptoParaGerar" class="header-icon el-icon-success success-icon")
              | {{ `Laudo do processo ${laudo.numeroProcesso}` }}
            el-card(shadow="hover").content
              app-divider(
                class="margim-bottom"
                label="Dados do processo"
              )
              div.filter-row
                app-par(chave="Número do processo" :valor="laudo.numeroProcesso")
                el-button(
                  type="primary",
                  @click="visualizarProcesso(laudo)",
                )
                  span
                    i.fal.fa-eye
                    | &nbsp Visualizar Processo
              el-row()
                app-display-com-input(:marginBottom="true" label="Número da OS" :content.sync="laudo.dadoLaudoDto.numeroOS", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="Data vistoria" :content.sync="laudo.dataVistoria", :name="`index_${index}_`")
              app-divider(
                class="margim-bottom"
                label="Dados do interessado"
              )
              el-row()
                app-display-com-input(:marginBottom="true" label="Nome" :content.sync="laudo.dadoLaudoDto.nomeRazaoSocial", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="CPF" :content.sync="laudo.dadoLaudoDto.cpfCnpj", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="Estado civil" :content.sync="laudo.dadoLaudoDto.estadoCivil", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="Telefones" :content.sync="laudo.dadoLaudoDto.telefones", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="Email" :content.sync="laudo.dadoLaudoDto.email", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="Renda familiar" :content.sync="laudo.dadoLaudoDto.renda", :name="`index_${index}_`")
              app-divider(
                class="margim-bottom"
                label="Informação de localização do imóvel"
              )
              el-row()
                app-display-com-input(:marginBottom="true" label="Nome do imóvel" :content.sync="laudo.dadoLaudoDto.nomeImovel", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="Município do imóvel" :content.sync="laudo.dadoLaudoDto.municipioImovel", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="Localização" :content.sync="laudo.dadoLaudoDto.localizacaoImovel", :name="`index_${index}_`")
              app-divider(
                class="margim-bottom"
                label="Dados da ocupação"
              )
              el-row()
                app-display-com-input(:marginBottom="true" label="Há ocupantes anteriores?" :content.sync="laudo.dadoLaudoDto.ocupantesAnterior", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="Tem posse mansa e pacífica?" :content.sync="laudo.dadoLaudoDto.temPosseMansaPacifica", :name="`index_${index}_`")
              el-row()
                app-display-com-input(:marginBottom="true" label="É uma unidade autônoma produtiva e sem fracionamento?" :content.sync="laudo.dadoLaudoDto.unidadeAutomaProdutivaSemFracionamento", :name="`index_${index}_`")
              app-divider(
                class="margim-bottom"
                label="Dados da ocupação"
              )
              el-row()
                app-display-com-input(:marginBottom="true" label="Tem atividade agrária?" :content.sync="laudo.dadoLaudoDto.temAtividadeAgraria", :name="`index_${index}_`")
              app-documentos(
                :idUploadDocumento="`documentos${index}`"
                titulo="Documetos"
                :maxSize='25000'
                :valid-extensions="['png','jpg','jpeg','zip']"
                :documentos="laudo.documentos"
                :tiposDocumentos="tiposDocumento"
                :tiposDocumentosObrigatorios="tiposDocumento"
                :removeOutros="true"
                :idLaudoDiagnostico="laudo.id",
                :observer="$refs.validation"
                :aba="`index_${index}_`"
              )
              el-row.filter-row
                app-button(
                  titulo="Salvar análise",
                  tipo="success",
                  size="medium",
                  icone="times-circle",
                  method="salvar",
                  @salvar="salvar(laudo, index)"
                )
</template>

<script>
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppModal from '@/components/AppModal'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao.vue'
import AppDisplayComInput from '@/components/AppDisplayComInput.vue'
import AppDocumentos from '../central/components/cadastro/AppDocumentos.vue'
import AppButton from '@/components/AppButton.vue'
import AppPar from '@/components/AppPar'

export default {
  components: {
    AppModal,
    AppRadiosTramitacao,
    AppLabel,
    AppDisplayComInput,
    AppDivider,
    AppDocumentos,
    AppButton,
    AppPar
  },
  props: {
    idLaudos: {
      type: Array,
      required: false
    },
    showModal: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    laudos: {
      type: Array,
      required: true
    }
  },
  mixins: [
    AppNotificacao
  ],
  data () {
    return {
      activeNames: [],
      tiposDocumento: [],
      files: [],
      idsLaudosGerar: [],
      responseDocumentos: [],
      defaultHeaderStyle: {
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
        border: 'none',
        'border-top-left-radius': '10px',
        'border-top-right-radius': '10px',
        'min-height': '700px',
        height: '50px',
        'background-color': '#289f61',
        'padding-left': '20px',
        'padding-right': '20px'
      }
    }
  },
  async created () {
    this.tiposDocumento = await this.findDocumentos('diagnostico')
  },
  methods: {
    ...mapActions({
      analiseConjuta: 'processo/analiseConjunta',
      findDocumentos: 'tipoDocumento/findTiposDocumento',
      updateLaudo: 'diagnostico/update'
    }),
    closeModal () {
      this.$emit('closeModal')
    },
    async salvar (laudo, index) {
      const valido = await this.$refs.validation.validate()
      const hasError = Object.entries(this.$refs.validation.errors).some(([key, value]) => key.startsWith(`index_${index}`) && value.length > 0)
      if (!valido && hasError) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE_LAUDO
        )
      }
      if (laudo.documentos && laudo.documentos.length > 0) {
        laudo.documentos = laudo.documentos.map(doc => {
          if (!doc.id) {
            return this.formatDocumento(doc)
          }
          return doc
        })
      }
      const laudoSalvo = await this.updateLaudo(laudo)
      this.laudos = this.laudos.map(l => l.id === laudoSalvo.id ? laudoSalvo : l)
    },
    formatDocumento (d) {
      return {
        id: d.id,
        tipo: d.tipoDocumento || d.tipo,
        key: d.fileKey || d.key,
        nome: d.fileName || d.name,
        fileName: d.fileName || d.name,
        fileKey: d.fileKey || d.key,
        tipoDocumento: d.tipoDocumento || d.tipo
      }
    },
    async validar () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
      }
    },
    visualizarProcesso (item) {
      window.open(`?protocolo=${item.protocolo}/#/visualizarProcesso`, `Visualizar processo ${item.numeroProcesso}`, 'height=500,width=800,top=25%, left=50%')
    },
    getLabel (laudo) {
      return laudo.codigoSituacao === 'AGUARDANDO_GERACAO' ? 'Gerando despacho' : 'Não apto para gerar, preencha todos os dados.'
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}
.center {
  margin-top: 40px !important;
  text-align: center;
}
.content {
  height: auto;
}
.margim-bottom {
  margin-bottom: 10px;
}

.filter-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.header-icon {
  margin-right: 5px;
}

.warning-icon {
  color: #f3a530;
}

.success-icon {
  color: #009f61;
}

</style>



// WEBPACK FOOTER //
// src/screens/diagnostico/AppModalLaudo.vue